export const SCHEMA_VERSION = '1.0.0';
export const CONSENT_VERSION = '2026.10.1';
export const LANDMARK_COUNT = 33;
/** Throttle pose samples into the 15–30 Hz training band. */
export const TARGET_CAPTURE_HZ = 20;
export const MIN_FRAME_INTERVAL_MS = 1000 / TARGET_CAPTURE_HZ;
export const MAX_CAPTURE_FRAMES = 2400;
export const MAX_QUEUE_ITEMS = 40;
export const RESEARCH_CONSENT_KEY = 'moveage_research_consent';
export const RESEARCH_PROFILE_KEY = 'moveage_research_profile';
export const RESEARCH_DB_NAME = 'MoveAgeResearchQueue';

export const POSE_LANDMARK_NAMES = [
  'nose',
  'left_eye_inner',
  'left_eye',
  'left_eye_outer',
  'right_eye_inner',
  'right_eye',
  'right_eye_outer',
  'left_ear',
  'right_ear',
  'mouth_left',
  'mouth_right',
  'left_shoulder',
  'right_shoulder',
  'left_elbow',
  'right_elbow',
  'left_wrist',
  'right_wrist',
  'left_pinky',
  'right_pinky',
  'left_index',
  'right_index',
  'left_thumb',
  'right_thumb',
  'left_hip',
  'right_hip',
  'left_knee',
  'right_knee',
  'left_ankle',
  'right_ankle',
  'left_heel',
  'right_heel',
  'left_foot_index',
  'right_foot_index',
] as const;
